const baseTheme = () => {
    return {
        palette: {
            primary: {
                main: '#c65431',
                hover: '#522e1f'
            }
        }
    };
};
const themeDependent = (theme) => {
    return null;
};

export default {
    baseTheme,
    themeDependent
};
